import RouteItem from ".";
import CoCurricularEvents from "../pages/events/Co-curricularEvents";
import PageUnderConstruction from "../pages/error-page/PageUnderConstruction";
import CurricularEvents from "../pages/events/CurricularEvents";
import MUHSEventWorkshops from "../pages/events/MUHS_Event&_workshops";
import UpComingEvents from "../pages/events/UpcomingEvents";

// Events SubMenu Pages
export const eventsRoutes: RouteItem = {
  key: "router-events",
  title: "Events",
  tooltip: "Events",
  path: "/events",
  enabled: true,
  appendDivider: true,
  showInHeader: true,
  subRoutes: [
    {
      key: "router-curricular-events",
      title: "Curricular Events",
      tooltip: "Curricular Events",
      path: "curricular-events",
      enabled: true,
      component: CurricularEvents,
      appendDivider: true,
    },
    {
      key: "router-co-curricular-events",
      title: "Co-curricular Events",
      tooltip: "Co-curricular Events",
      path: "co-curricular-events",
      enabled: true,
      component: CoCurricularEvents,
      appendDivider: true,
    },
    {
      key: "router-muhs-events",
      title: "MUHS Events & Workshops",
      tooltip: "MUHS Events & Workshops",
      path: "muhs-events-workshops",
      enabled: true,
      component: MUHSEventWorkshops,
      appendDivider: true,
    },
    // {
    //   key: "router-upcoming-events",
    //   title: "Upcoming Events",
    //   tooltip: "Upcoming Events",
    //   path: "upcoming-events",
    //   enabled: true,
    //   component: UpComingEvents,
    //   appendDivider: true,
    // },
  ],
};
